export default "__VITE_ASSET__$Kdzaj4X__"